/**
 * Cancels currently running plugins. This is called from unmount or update
 * @param pluginState {HtmlPluginState} Holds cleanup callbacks and event subscriptions
 */
export function cancelCurrentlyRunningPlugins(pluginState) {
  pluginState.cleanupCallbacks.forEach(function (fn) {
    fn(); // resolve each promise with 'canceled'
  });
}